const CONF = {
    BRADMAN_END_POINT: '/api/',
    FILE_SIZE_LIMIT_FOR_LIQUIDATION_INGESTION_IN_BYTES: 3000000,
    DEFAULT_FILE_SIZE_LIMIT_FOR_INGESTION_IN_BYTES: 2000000,
    FILE_SIZE_LIMIT_FOR_PDF_IN_BYTES: 7000000,
    LEFT_MENU: [
        {
            display: 'Warehouse Visibility',
            id: 'WarehouseVisibility',
            link: 'WarehouseVisibility',
        },
        {
            display: 'User List',
            id: 'UserList',
            link: 'UserList',
            isExpandable: true,
            children: [],
        },
        {
            display: 'Job Operations',
            id: 'JobPutawayJobs',
            link: 'PutawayJobs',
            isExpandable: true,
            children: [
                {
                    display: 'Putaway Jobs',
                    id: 'PutawayJobs',
                    link: 'PutawayJobs',
                },
                {
                    display: 'IWT Jobs',
                    id: 'IWTJobs',
                    link: 'IWTJobs',
                },
                {
                    display: 'Pick Jobs',
                    id: 'PickJobs',
                    link: 'PickJobs',
                },
                {
                    display: 'Transfer Jobs',
                    id: 'TransferJobs',
                    link: 'TransferJobs',
                },
                {
                    display: 'Sorting Jobs',
                    id: 'SortingJobs',
                    link: 'SortingJobs',
                },
                {
                    display: 'Putaway Dashboard',
                    id: 'PutawayDashboard',
                    link: 'PutawayDashboard',
                },
                {
                    display: 'IWT Dashboard',
                    id: 'IWTDashboard',
                    link: 'IWTDashboard',
                },
                {
                    display: 'Transfer Dashboard',
                    id: 'TransferDashboard',
                    link: 'TransferDashboard',
                },
                // , {
                //     display: 'Sorting & Dashboard',
                //     id: 'SortingDashboard',
                //     link: 'SortingDashboard'
                // }
            ],
        },
        {
            display: 'Dispatch Jobs',
            id: 'DispatchJobs',
            link: 'VehicleMapping',
            isExpandable: true,
            children: [
                {
                    display: 'Vehicle Mapping',
                    id: 'VehicleMapping',
                    link: 'VehicleMapping',
                },
                {
                    display: 'Crate Sticker',
                    id: 'CrateSticker',
                    link: 'CrateSticker',
                },
            ],
        },
        {
            display: 'Inventory Operations',
            id: 'InventoryOperations',
            link: 'StockTake',
            isExpandable: true,
            children: [
                {
                    display: 'Stock Take',
                    id: 'StockTake',
                    link: 'StockTake',
                },
                // {
                //     display: 'Stock Correction',
                //     id: 'StockCorrection',
                //     link: 'StockCorrection'
                // },
                {
                    display: 'Stock Transfer',
                    id: 'StockTransfer',
                    link: 'StockTransfer',
                },
                {
                    display: 'IWT Transfer',
                    id: 'IWTTransfer',
                    link: 'IWTTransfer',
                },
                {
                    display: 'Change Status',
                    id: 'ChangeStatus',
                    link: 'ChangeStatus',
                },
            ],
        },
        {
            display: 'Space Operations',
            id: 'SpaceOperations',
            link: 'GenerateSpace',
            isExpandable: true,
            children: [
                {
                    display: 'Generate Space',
                    id: 'GenerateSpace',
                    link: 'GenerateSpace',
                },
                {
                    display: 'Space',
                    id: 'Space',
                    link: 'Space',
                },
                {
                    display: 'Product Allocation',
                    id: 'ProductAllocation',
                    link: 'ProductAllocation',
                },
                {
                    display: 'Geomarker',
                    id: 'Geomarker',
                    link: 'Geomarker',
                },
                {
                    display: 'Infrastructure',
                    id: 'Infrastructure',
                    link: 'Infrastructure',
                },
                {
                    display: 'Product Onboard',
                    id: 'ProductOnboard',
                    link: 'ProductOnboard',
                },
                {
                    display: 'Break Contingous Space',
                    id: 'BreakContingousSpace',
                    link: 'BreakContingousSpace',
                },
                {
                    display: 'Dynamic Space Allocation',
                    id: 'DynamicSpaceAllocation',
                    isExpandable: true,
                    children: [
                        {
                            display: 'Zone Ingestion',
                            id: 'ZoneIngestion',
                            link: 'DynamicSpaceAllocation/ZoneIngestion',
                        },
                        {
                            display: 'Product Infra Capacity Mapping',
                            id: 'ProductInfraCapacityMapping',
                            link: 'DynamicSpaceAllocation/ProductInfraCapacityMapping',
                        },
                    ],
                },
            ],
        },
        // {
        //     display: 'Space Search',
        //     id: 'SpaceSearch',
        //     link: 'ProductSearch',
        //     children: [{
        //         display: 'Product Search',
        //         id: 'ProductSearch',
        //         link: 'ProductSearch'
        //     }, {
        //         display: 'Space Barcode Search',
        //         id: 'SpaceBarcodeSearch',
        //         link: 'SpaceBarcodeSearch'
        //     }, {
        //         display: 'Product Barcode Search',
        //         id: 'ProductBarcodeSearch',
        //         link: 'ProductBarcodeSearch'
        //     }]
        // },
        {
            display: 'Liquidation',
            id: 'Liquidation',
            link: 'RequestLiquidation',
            isExpandable: true,
            children: [
                {
                    display: 'Request Liquidation',
                    id: 'RequestLiquidation',
                    link: 'RequestLiquidation',
                },
                {
                    display: 'Complete Liquidation',
                    id: 'CompleteLiquidation',
                    link: 'CompleteLiquidation',
                },
            ],
        },
        {
            display: 'Purchase Return',
            id: 'PurchaseReturn',
            link: 'RequestPurchaseReturn',
            isExpandable: true,
            children: [
                {
                    display: 'Request Purchase Return',
                    id: 'RequestPurchaseReturn',
                    link: 'RequestPurchaseReturn',
                },
                {
                    display: 'Accept Purchase Return',
                    id: 'AcceptPurchaseReturn',
                    link: 'AcceptPurchaseReturn',
                },
                {
                    display: 'Reject Purchase Return',
                    id: 'RejectPurchaseReturn',
                    link: 'RejectPurchaseReturn',
                },
            ],
        },
        {
            display: 'QC',
            id: 'QC',
            link: 'RequestQC',
            isExpandable: true,
            children: [
                {
                    display: 'Request QC',
                    id: 'RequestQC',
                    link: 'RequestQC',
                },
                {
                    display: 'Mark QC Fail',
                    id: 'MarkQCFail',
                    link: 'MarkQCFail',
                },
                {
                    display: 'Mark QC Pass',
                    id: 'MarkQCPass',
                    link: 'MarkQCPass',
                },
                {
                    display: 'Mark QC Dispatch',
                    id: 'MarkQCDispatch',
                    link: 'MarkQCDispatch',
                },
            ],
        },
        {
            display: 'Returns',
            id: 'SellerReturns',
            link: 'ViewDeliveryChallan',
            isExpandable: true,
            children: [
                {
                    display: 'View Delivery Challan',
                    id: 'ViewDeliveryChallan',
                    link: 'ViewDeliveryChallan',
                },
                {
                    display: 'Generate Delivery Challan',
                    id: 'GenerateDeliveryChallan',
                    link: 'GenerateDeliveryChallan',
                },
                {
                    display: 'Seller Return Window',
                    id: 'SellerReturnWindow',
                    link: 'SellerReturnWindow',
                },
                {
                    display: 'Return Dispatch',
                    id: 'ReturnDispatch',
                    link: 'ReturnDispatch',
                },
                {
                    display: 'Liquidation Dispatch',
                    id: 'LiquidationDispatch',
                    link: 'LiquidationDispatch',
                },
                {
                    display: 'SRR Status Transition',
                    id: 'srrStatusTransition',
                    link: 'GoodsStatusUpdate',
                },
            ],
        },
        {
            display: 'Seller Receiving',
            id: 'SellerReceiving',
            link: 'ReceivingFacilityMapping',
            isExpandable: true,
            children: [
                {
                    display: 'Receiving Facility Mapping',
                    id: 'ReceivingFacilityMapping',
                    link: 'ReceivingFacilityMapping',
                },
            ],
        },
        // {
        //     display: 'Invoice Control',
        //     id: 'InvoiceControl',
        //     link: 'InvoiceControl',
        //     children: []
        // },
        {
            display: 'Inwarding',
            id: 'Inwarding',
            link: 'Inwarding',
            isExpandable: false,
            children: [],
        },
        {
            display: 'APK\'s',
            id: 'APKs',
            link: 'APKs',
            isExpandable: false,
            children: [],
        },
        {
            display: 'Turing',
            id: 'Turing',
            header: true,
            isExpandable: false,
            children: [
                {
                    display: 'Inwarding',
                    id: 'Inwardings',
                    isExpandable: true,
                    children: [
                        {
                            display: 'ASN',
                            id: 'ASN',
                            link: 'Inwarding-ASN',
                        },
                        {
                            display: 'Putaway',
                            id: 'Putaway',
                            link: 'Inwarding-Putaway',
                        },
                        {
                            display: 'Contingency',
                            id: 'Contingency',
                            link: 'Inwarding-Contingency',
                        },
                    ],
                },
                {
                    display: 'Picking',
                    id: 'Picking',
                    isExpandable: true,
                    children: [
                        {
                            display: 'Progress',
                            id: 'Picking-Progress',
                            link: 'Picking-Progress',
                        },
                        {
                            display: 'Missing Damages',
                            id: 'Missing-Damages',
                            link: 'Picking-Missing-Damages',
                        },
                    ],
                },
                {
                    display: 'Sorting',
                    id: 'Sorting',
                    isExpandable: true,
                    children: [
                        {
                            display: 'Progress',
                            id: 'Sorting-Progress',
                            link: 'Sorting-Progress',
                        },
                    ],
                },
                {
                    display: 'Stock Take',
                    id: 'Stock-Take',
                    isExpandable: true,
                    children: [
                        {
                            display: 'Low Shelf Life Check',
                            id: 'Stock-Take-Dump',
                            link: 'Stock-Take-Dump',
                        },
                    ],
                },
                {
                    display: 'Returns',
                    id: 'Returns',
                    isExpandable: true,
                    children: [
                        {
                            display: 'Returns Tracking',
                            id: 'Returns-Tracking',
                            link: 'Returns-Tracking',
                        },
                    ],
                },
                {
                    display: 'Capacity',
                    id: 'Capacity',
                    isExpandable: true,
                    children: [
                        {
                            display: 'Warhouse Capacities',
                            id: 'Warhouse-Capacities',
                            link: 'Warhouse-Capacities',
                        },
                    ],
                },
                {
                    display: 'Pan India',
                    id: 'Pan-India',
                    isExpandable: true,
                    children: [
                        {
                            display: 'Operation Tracking',
                            id: 'Operation-Tracking',
                            link: 'Operation-Tracking',
                        },
                    ],
                },
                // {
                //     display: 'Inventory',
                //     id: 'Inventory',
                //     link: 'Inventory-Tracking',
                // },
            ],
        },
    ],
    DASHBOARD_IDS: {
        'Inwarding-ASN': 88,
        'Inwarding-Putaway': 16,
        'Inwarding-Contingency': 31,
        'Picking-Progress': 8,
        'Picking-Missing-Damages': 42,
        'Sorting-Progress': 27,
        'Stock-Take-Dump': 29,
        'Returns-Tracking': 25,
        'Warhouse-Capacities': 43,
        'Operation-Tracking': 209,
    },
    emailsAllowedForNewCountingScreen: [
        'anansh.srivastava@jumbotail.com',
        'balram.s@jumbotail.com',
        'harjeet.singh@jumbotail.com',
        'priti.sharma@jumbotail.com',
        'ranjan.kumar@jumbotail.com',
        'sandeep.k@jumbotail.com',
        'sayam.saraswat@jumbotail.com',
        'skand.kumar@jumbotail.com',
        'subramanian.raman@jumbotail.com',
        'lakshmiprasad.n@jumbotail.com',
        'vidhi.malhotra@jumbotail.com',
        'vikhyat.bhatnagar@jumbotail.com',
        'saurav.bhagat@jumbotail.com',
        'lakshmi.konchada@jumbotail.com',
    ],

    facilitiesAllowedForNewCountingScreen: [
        'Yard',
        'FC-Ahmedabad',
        'FC-Bhubaneswar',
        'FC-Chandigarh',
        'FC-Chennai',
        'FC-Coimbatore',
        'FC-Faridabad',
        'FC-Ghaziabad',
        'FC-Gurgaon',
        'FC-Hyderabad',
        'FC-Jaipur',
        'FC-Lucknow',
        'FC-Ludhiana',
        'FC-Patna',
        'FC-Pune',
        'FC-Ranchi',
        'FC-Trichy',
        'FC-Vijayawada',
        'Sutlej/Gomati',
        'Vajra',
        'Vayu',
        'Vikrant',
    ],

    superUsers: [
        'vikhyat.bhatnagar@jumbotail.com',
        'lakshmi.konchada@jumbotail.com',
    ],

    changeStatusAllowedUsers: [
        'nikhil.bhatnagar@jumbotail.com',
    ],

    bannedUsers: [],
    specialDateFacilitiesD2: [],
    specialDateFacilitiesD3: [],
    specialDateFacilitiesD4: [],
    facilitiesRequiringSpaceConfig: ['FACIL-1441685588', 'FACIL-1441685309', 'FACIL-1441685366', 'FACIL-1441685367', 'FACIL-1441688365', 'FACIL-1441684917'],

    // "target": "http://test.api.jumbotail.com:7101",
};

export default CONF;



// WEBPACK FOOTER //
// ./src/config/config.js